import ValidateEntityObject from '@/shared/utils/validate-entity-object';
import Directive from './directive.entity';

export default class DirectiveDefinition {
  private id?: string;

  private directive: Directive;

  private activated: boolean;

  private inheritance?: boolean;

  private diverging?: boolean;

  constructor(obj: any = {}) {
    if (obj.id) this.id = obj.id;
    this.directive = ValidateEntityObject.validate(obj.directive, Directive.of);
    this.activated = obj.activated;
    if (typeof obj.inheritance === 'boolean') this.inheritance = obj.inheritance;
    if (typeof obj.diverging === 'boolean') this.diverging = obj.diverging;
  }

  public static of(value: any): DirectiveDefinition {
    return new DirectiveDefinition(value || {});
  }

  public static ofList(response: any): DirectiveDefinition[] {
    return response.map(this.of);
  }
}
